export default __webpack_public_path__ + "static/media/Landscape-Noise-0.1.77e52e92.jpg";